import { Button } from '@mantine/core';
import { AiOutlinePlus } from 'react-icons/ai';
import { useState } from 'react';
import { Product } from '../../products/types';
import { createStripeProduct } from '../services/StripeProductService';

interface CreateStripeProductButtonProps {
    product: Product;
    onProductCreated?: (stripeProductId: string) => void;
}

export const CreateStripeProductButton = ({ product, onProductCreated }: CreateStripeProductButtonProps) => {
    const [loading, setLoading] = useState(false);

    const handleCreate = async () => {
        setLoading(true);
        try {
            const stripeProduct = await createStripeProduct(product.id, {
                name: product.name,
                description: product.shortDescription || product.longDescription
            });
            
            if (stripeProduct?.id && onProductCreated) {
                onProductCreated(stripeProduct.id);
            }
        } catch (error) {
            console.error('Failed to create Stripe product:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            leftSection={<AiOutlinePlus size={16} />}
            size="xs"
            variant="light"
            loading={loading}
            onClick={handleCreate}
        >
            Create in Stripe
        </Button>
    );
};